import { configureStore } from '@reduxjs/toolkit'
import root from '../reducers';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
export default configureStore({
    reducer: root,
})